import React from "react";
import PrivacyFooter from "./PrivacyFooter";

function Footer() {
  return (
    <footer className="font-Apercu-Regular footer flex-shrink-0 w-full">
      <div className="bg-srgray-secondary">
        <PrivacyFooter />
      </div>
    </footer>
  );
}

export default Footer;
